// src/components/BotonWhatsapp.js
import React from 'react';
import './BotonWhatsapp.css';
import whatsappIcon from '../assets/WhatsApp.png';

const BotonWhatsapp = () => {
  return (
    <a
      href="https://wa.me/5215644811995"
      className="whatsapp-flotante"
      target="_blank"
      rel="noopener noreferrer"
    >
         <img src={whatsappIcon} alt="WhatsApp" className="whatsapp-icon" />
      ¿Tienes dudas? Contáctanos.
    </a>
  );
};

export default BotonWhatsapp;
